import React, { lazy, Component } from 'react';
import { ShieldCheck, Video, Maximize, MapPin, Clock, Printer } from 'lucide-react';
import { Button } from './ui/Button';
export function Flyer() {
  const handlePrint = () => {
    window.print();
  };
  // Tracking URL for QR code with UTM parameters
  const trackingUrl = 'https://holdmyvan.com.au?utm_source=flyer&utm_medium=qr_code&utm_campaign=caravan_park_noticeboards';
  return <div className="min-h-screen bg-gray-100 p-8 flex flex-col items-center justify-center font-sans" data-id="element-180">
      {/* Print Button - Hidden when printing */}
      <div className="mb-8 print:hidden" data-id="element-181">
        <Button onClick={handlePrint} className="flex items-center gap-2 shadow-lg" data-id="element-182">
          <Printer className="h-5 w-5" data-id="element-183" />
          Print Flyer
        </Button>
        <p className="mt-2 text-sm text-gray-500 text-center" data-id="element-184">
          Best printed in Portrait / A4
        </p>
      </div>

      {/* A4 Flyer Container */}
      <div className="bg-[#fbf7dd] w-[210mm] min-h-[297mm] shadow-2xl print:shadow-none print:w-full print:h-full relative overflow-hidden flex flex-col" data-id="element-185">
        {/* Header */}
        <header className="bg-[#175445] text-[#fbf7dd] p-6 flex justify-between items-center print:bg-[#175445] print:text-[#fbf7dd] print-color-adjust-exact" data-id="element-186">
          <img src="https://cdn.magicpatterns.com/uploads/8iyBWSo8vRExHMrz3iz275/Hold_My_Van_Full_Colour_Logo_1500px_V1.png" alt="Hold My Van" className="h-12 w-12" loading="lazy" width="48" height="48" data-id="element-187" />
          <div className="bg-[#FFC107] text-black px-4 py-2 rounded-full text-sm font-bold uppercase tracking-wider print:bg-[#FFC107] print:text-black" data-id="element-188">
            Coming Soon to Perth
          </div>
        </header>

        {/* Hero Section */}
        <div className="relative h-64 overflow-hidden" data-id="element-189">
          <img src="https://cdn.magicpatterns.com/uploads/4H7vMpv3GeDGEYCVvASyPc/Hold_my_van_hero.jpg" alt="Caravan Storage" className="w-full h-full object-cover" loading="lazy" width="800" height="256" data-id="element-190" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#175445]/90 to-transparent flex flex-col justify-end p-8" data-id="element-191">
            <h1 className="text-4xl font-bold text-[#fbf7dd] leading-tight drop-shadow-md mb-2" data-id="element-192">
              A safer home for your <br data-id="element-193" /> caravan or boat
            </h1>
            <p className="text-xl text-[#FFC107] font-bold" data-id="element-194">
              Close to Perth - Within 35km of CBD
            </p>
          </div>
        </div>

        {/* Subheading Section */}
        <div className="px-8 pt-6 pb-4 bg-gray-50" data-id="element-195">
          <p className="text-center text-gray-700 text-lg leading-relaxed" data-id="element-196">
            Hold My Van offers a simple, secure alternative to parking your
            caravan, boat or motorhome on your driveway or verge.
          </p>
        </div>

        {/* Main Content */}
        <div className="p-8 flex-grow" data-id="element-197">
          <div className="grid grid-cols-2 gap-8 mb-8" data-id="element-198">
            {/* Left Column: Features */}
            <div className="space-y-6" data-id="element-199">
              <h2 className="text-2xl font-bold text-[#175445] border-b-2 border-[#FFC107] inline-block pb-1 mb-2" data-id="element-200">
                Secure Storage
              </h2>

              <ul className="space-y-4 list-disc list-inside" data-id="element-201">
                <li className="flex items-start gap-3" data-id="element-202">
                  <Video className="h-6 w-6 text-[#175445] flex-shrink-0" data-id="element-203" />
                  <div data-id="element-204">
                    <span className="font-bold block text-gray-900" data-id="element-205">
                      24/7 Video Monitoring
                    </span>
                    <span className="text-sm text-gray-600" data-id="element-206">
                      CCTV covering all angles
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-207">
                  <ShieldCheck className="h-6 w-6 text-[#175445] flex-shrink-0" data-id="element-208" />
                  <div data-id="element-209">
                    <span className="font-bold block text-gray-900" data-id="element-210">
                      Secure Gated Access
                    </span>
                    <span className="text-sm text-gray-600" data-id="element-211">
                      Perimeter fencing & gates
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-212">
                  <Maximize className="h-6 w-6 text-[#175445] flex-shrink-0" data-id="element-213" />
                  <div data-id="element-214">
                    <span className="font-bold block text-gray-900" data-id="element-215">
                      Spacious Bays
                    </span>
                    <span className="text-sm text-gray-600" data-id="element-216">
                      9m x 3m bay size
                    </span>
                  </div>
                </li>
                <li className="flex items-start gap-3" data-id="element-217">
                  <Clock className="h-6 w-6 text-[#175445] flex-shrink-0" data-id="element-218" />
                  <div data-id="element-219">
                    <span className="font-bold block text-gray-900" data-id="element-220">
                      Flexible Terms
                    </span>
                    <span className="text-sm text-gray-600" data-id="element-221">
                      Month-by-month, no lock-in
                    </span>
                  </div>
                </li>
              </ul>
            </div>

            {/* Right Column: Pricing & QR */}
            <div className="flex flex-col items-center justify-center space-y-6" data-id="element-222">
              {/* Pricing Box */}
              <div className="bg-gray-50 border-2 border-[#175445] rounded-xl p-6 text-center w-full shadow-sm print:border-2" data-id="element-223">
                <p className="text-gray-500 text-sm uppercase tracking-wide font-bold mb-1" data-id="element-224">
                  Standard Bay
                </p>
                <div className="text-5xl font-bold text-[#175445] mb-2" data-id="element-225">
                  <span className="text-lg font-normal" data-id="element-226">from</span> $29
                  <span className="text-lg text-gray-500 font-normal" data-id="element-227">/wk</span>
                </div>
                <div className="bg-[#FFC107] text-black font-bold py-1 px-3 rounded-full text-sm inline-block" data-id="element-228">
                  Early bird pricing available
                </div>
              </div>

              {/* QR Code with Tracking */}
              <div className="text-center" data-id="element-229">
                <div className="bg-[#fbf7dd] p-2 border border-gray-200 rounded-lg inline-block mb-2" data-id="element-230">
                  <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(trackingUrl)}&color=1A7B7E`} alt="Scan to Register" className="w-32 h-32" loading="lazy" width="128" height="128" data-id="element-231" />
                </div>
                <p className="font-bold text-[#175445] text-lg" data-id="element-232">
                  Scan to Register Interest
                </p>
                <p className="text-gray-500 text-sm" data-id="element-233">
                  or visit holdmyvan.com.au
                </p>
              </div>
            </div>
          </div>

          <div className="text-center mt-4 p-4 bg-[#175445]/10 rounded-lg border border-[#175445]/20" data-id="element-234">
            <p className="text-[#175445] font-bold text-lg" data-id="element-235">
              Limited spaces available at launch!
            </p>
            <p className="text-gray-700" data-id="element-236">
              Join the priority list today to secure your spot and lock in early
              bird pricing.
            </p>
          </div>
        </div>

        {/* Tear-off Strips */}
        <div className="flex border-t-2 border-dashed border-gray-300 mt-auto" data-id="element-237">
          {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className="flex-1 border-r border-dashed border-gray-300 h-40 relative group last:border-r-0" data-id="element-238">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-239">
                <div className="transform -rotate-90 whitespace-nowrap text-center" data-id="element-240">
                  <p className="font-bold text-[#175445] text-lg" data-id="element-241">
                    HOLDMYVAN.COM.AU
                  </p>
                  <p className="text-sm font-medium" data-id="element-242">Caravan & Boat Storage</p>
                  <p className="text-xs text-gray-500" data-id="element-243">Scan QR or Visit Site</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>

      <style data-id="element-244">{`
        @media print {
          @page {
            size: A4 portrait;
            margin: 0;
          }
          body {
            background: white;
            padding: 0;
          }
          .print\\:hidden {
            display: none !important;
          }
          .print\\:shadow-none {
            box-shadow: none !important;
          }
          .print\\:w-full {
            width: 100% !important;
          }
          .print\\:h-full {
            height: 100% !important;
          }
          /* Ensure colors print correctly */
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}</style>
    </div>;
}